import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import LogoBrandContainer from "app/pages/.shared/LogoBrand/LogoBrandContainer";
import PartnershipWithPFSLabel from "app/pages/.shared/PartnershipWithPFSLabel/PartnershipWithPFSLabel";

import "./PrintHeader.scss";

const useContrastColor = ({ color }) => {
	let red, green, blue;

	//parse input string to split by colors
	//see https://stackoverflow.com/a/9586150
	var matchColors = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/;
	var match = matchColors.exec(color);
	if (match !== null) {
		red = match[1];
		green = match[2];
		blue = match[3];
	}

	//get contrast color based on input color
	//see https://stackoverflow.com/a/3943023
	if (red * 0.299 + green * 0.587 + blue * 0.114 > 186) {
		return { contrastColor: "black" };
	}
	return { contrastColor: "white" };
};

const PrintHeader = ({ showPfsMessage }) => {
	const ref = useRef();

	const [backgroundColor, setBackgroundColor] = useState();

	const { contrastColor } = useContrastColor({ color: backgroundColor });

	useEffect(() => {
		setBackgroundColor(getComputedStyle(ref.current).backgroundColor);
	}, [ref]);

	return (
		<div
			ref={ref}
			className="print-header"
			style={{ color: contrastColor === "black" ? "var(--color-black)" : "#ffffff" }}
		>
			<LogoBrandContainer isWhite={contrastColor === "white"} />
			{showPfsMessage && <PartnershipWithPFSLabel isWhite={contrastColor === "white"} />}
		</div>
	);
};

PrintHeader.propTypes = {
	showPfsMessage: PropTypes.bool,
};

export default PrintHeader;
